<template>
  <div id="app">
    <pc-loader></pc-loader>
  </div>
</template>

<script>
import pcLoader from './components/pc-loader.vue';

export default {
  components: {
    pcLoader,
  },
};
</script>
<style>
#privacy-center-body {
  background-color: transparent;
}
</style>
